/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ContainerForProductionOrder } from '../../models/container-for-production-order';

export interface ContainerForProductionOrder$Params {
  externalProductionOrderId: string;
}

export function containerForProductionOrder(http: HttpClient, rootUrl: string, params: ContainerForProductionOrder$Params, context?: HttpContext): Observable<StrictHttpResponse<ContainerForProductionOrder>> {
  const rb = new RequestBuilder(rootUrl, containerForProductionOrder.PATH, 'get');
  if (params) {
    rb.path('externalProductionOrderId', params.externalProductionOrderId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ContainerForProductionOrder>;
    })
  );
}

containerForProductionOrder.PATH = '/api/v1/PackLine/productionOrders/{externalProductionOrderId}/containers';
